import { useEffect, useState } from "react";
import { Navbar } from "@/components/Navbar";
import { LiveNowBanner } from "@/components/LiveNowBanner";
import { Footer } from "@/components/Footer";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";

const Explore = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/posts/explore").then(({ data }) => {
      setPosts(data);
      setLoading(false);
    });
  }, []);

  return (
    <div data-testid="explore-page" className="app-shell">
      <Navbar />
      <LiveNowBanner />
      <div className="container-belle" style={{ paddingTop: 110, paddingBottom: 48 }}>
        <div style={{ marginBottom: 48, maxWidth: 720 }}>
          <div className="overline" style={{ color: "var(--brand-accent)" }}>Discover</div>
          <h1 className="editorial-h1" style={{ fontSize: "clamp(40px, 6vw, 72px)", marginTop: 12 }}>
            A wandering<br />through the salon.
          </h1>
          <p className="editorial-body" style={{ fontSize: 17, marginTop: 16 }}>
            Photographs and short films from our community — a quiet, scrolling magazine of women living well.
          </p>
        </div>

        {loading ? (
          <p style={{ color: "var(--text-muted)" }}>Loading…</p>
        ) : (
          <div style={{ columnCount: 3, columnGap: 16 }} className="explore-grid">
            {posts.map((p, i) => (
              <Link
                key={p.id}
                to={`/post/${p.id}`}
                data-testid={`explore-tile-${p.id}`}
                className="media-zoom"
                style={{
                  display: "block",
                  marginBottom: 16,
                  breakInside: "avoid",
                  overflow: "hidden",
                  border: "1px solid var(--border-default)",
                  background: "var(--surface)",
                  animation: `fadeUp 0.7s ease-out ${i * 0.04}s both`,
                }}
              >
                {p.media_type === "video" ? (
                  <video src={p.media_url} muted style={{ width: "100%", display: "block" }} />
                ) : (
                  <img loading="lazy" decoding="async" src={p.media_url} alt="" style={{ width: "100%", display: "block" }} />
                )}
                {p.caption && (
                  <div style={{ padding: "14px 16px", borderTop: "1px solid var(--border-default)" }}>
                    <div className="overline">@{p.author?.username}</div>
                    <p className="font-serif" style={{ fontSize: 15, fontStyle: "italic", margin: "6px 0 0", lineHeight: 1.4 }}>
                      {p.caption.length > 90 ? p.caption.slice(0, 90) + "…" : p.caption}
                    </p>
                  </div>
                )}
              </Link>
            ))}
          </div>
        )}
      </div>
      <Footer />
      <style>{`
        @media (max-width: 900px) { .explore-grid { column-count: 2 !important; } }
        @media (max-width: 540px) { .explore-grid { column-count: 1 !important; } }
      `}</style>
    </div>
  );
};

export default Explore;
